// NavNotificationButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, IconSection, TooltipStyle } from '../style/NavHeader.js';
import Tooltip from '../component/Tooltip.jsx';
import NotificationButton from '../container/NotificationButton.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { useTranslation } from 'react-i18next';

export const NavNotificationButton = ({
  isNotificationCenterOpened = false,
}) => {
  const { t } = useTranslation();

  return (
    <IconSection>
      <Tooltip
        position="bottom-center"
        renderHint={() => (
          <TooltipStyle>
            {t('notification_center_title', {
              ns: TranslationNamespace.GENERAL,
            })}
          </TooltipStyle>
        )}
        trigger="hover"
      >
        <NotificationIcon
          as="div"
          isMatch={isNotificationCenterOpened}
          aria-label={t('notification_center_title', {
            ns: TranslationNamespace.GENERAL,
          })}
        >
          <NotificationButton />
        </NotificationIcon>
      </Tooltip>
    </IconSection>
  );
};

NavNotificationButton.propTypes = {
  isNotificationCenterOpened: PropTypes.bool,
};

const NotificationIcon = styled(Icon)``;

export default NavNotificationButton;
